import styled from "styled-components"

export const TestimonialWrapp = styled.section`
  background: #f7f5f0;
  border-top: 1px solid #e7e2d8;

  .testimonial {
    padding: 56px 0;

    .title {
      text-align: center;
      font-size: 2.4rem;
      font-weight: 700;
      margin-bottom: 24px;
      color: #17201b;
      letter-spacing: 0;
    }

    .testimonial-card-container {
      display: grid;
      grid-template-columns: repeat(4, minmax(240px, 1fr));
      gap: 14px;

      @media (max-width: 1440px) {
        overflow-x: scroll;
        ::-webkit-scrollbar {
          display: none;
        }
      }

      @media (max-width: 761px) {
        grid-template-columns: 1fr;
        overflow: visible;
      }
    }

  }
`
